
import BitcoinConvert from "../../../assets/duotone/BitcoinConvert.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BitcoinConvertIcon({ className, dataTestid = "BitcoinConvertIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BitcoinConvert data-testid={dataTestid} className={classes} {...rest} />
  );
}
